<template>
  <div class="notification-container">
    <v-alert
      v-for="(notification, index) in notifications"
      :id="notification.id"
      :key="index"
      :border="notification.border"
      :colored-border="notification.coloredBorder"
      :color="notification.color"
      :dismissible="notification.dismissible"
      :dense="notification.dense"
      :elevation="notification.elevation"
      :icon="notification.icon"
      :outlined="notification.outlined"
      :type="notification.type"
      class="global-notification"
      @input="removeNotification(notification.id)">
      <span v-if="notification.title">
        <b>{{notification.title}}</b><br>
      </span>
      <span v-html="notification.message"></span>
      <slot #append></slot>
      <slot #prepend></slot>
    </v-alert>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters(['notifications'])
  },
  methods: {
    ...mapActions(['removeNotification'])
  }
};
</script>

<style scoped>
.notification-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 450px;
}
.global-notification {
  min-width: 250px;
}
</style>
